import React from 'react';

import { CoreLink } from '@uncinc/react-drupal-core';

import type { BaseCardProps } from '../types';

const CardLink: React.FC<Pick<BaseCardProps, 'href'>> = (props) => {
  const { href, children } = props;

  return (
    <CoreLink className="Card__link" href={href}>
      {children}
    </CoreLink>
  );
};

export default CardLink;
